<template>
    <div>
        <div class="orders-list-container">
            <table class="orders-list-panel1">
                <tbody class="orders-body">
                <tr class="blank-row">
                    <td colspan="5"></td>
                </tr>
                <tr class="abstract-row">
                    <td colspan="5">
                        <div class="search-container primary fr">
                            <div class="form-box">
                                <input class="input-field" v-model="merchantName" placeholder="输入商户名称"/>
                                <button class="search-btn" @click="getDealReplyVoucherList()"><i class="icon iconfont icon-search"></i></button>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="info-row" v-for="dealReplyVoucher in dealReplyVoucherList">
                    <td colspan="5" class="align-left">
                        <div class="form-single">
                            <div class="title">商户名称</div>
                            <div class="content" style="width: auto;">
                                <span>{{dealReplyVoucher.merchantName}}</span>
                                <span class="fr font12">报盘日期：{{dealReplyVoucher.replyTime}}</span>
                            </div>
                        </div>
                        <div class="form-single">
                            <div class="title">报盘附件</div>
                            <div class="content">
                                <div class="file-area clearfix">
                                    <swb-file-item v-for="(file, index) in dealReplyVoucher.dealReplyFileList" :trackKey="index" :fileName="file.name" :fileUuid="file.fileUuid" :fileBrowseUrl="file.fileBrowseUrl" :fileDownloadUrl="file.fileDownloadUrl" :fileMd5="file.fileMd5"></swb-file-item>
                                </div>
                            </div>
                        </div>
                        <div class="form-single">
                            <div class="title">报盘摘要</div>
                            <div class="content">
                                <span>{{dealReplyVoucher.digest}}</span>
                            </div>
                        </div>
                        <div class="form-single">
                            <div class="title">商户留言</div>
                            <div class="content">
                                <span>{{dealReplyVoucher.leftWords}}</span>
                            </div>
                        </div>
                        <div class="form-single">
                            <div class="title">联系人</div>
                            <div class="content">
                                <span>{{dealReplyVoucher.contactName}}</span>
                            </div>
                        </div>
                        <div class="form-single">
                            <div class="title">联系电话</div>
                            <div class="content">
                                <span>{{dealReplyVoucher.contactTel}}</span>
                            </div>
                        </div>
                        <div class="form-single">
                            <div class="title">&nbsp;</div>
                            <div class="content" style="width: auto;">
                                <button class="swb-btn swb-btn-small fr" @click="addQualifiedMerchant(dealReplyVoucher.merchantId, dealReplyVoucher.merchantType)">
                                    加入备选供方

                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import dealApi from '../../api/deal'
    import merchtComnApi from '../../api/merchtComn'

    export default{
        name: 'swb-deal-reply-voucher-list',
        desc: '报盘单列表',
        props: ['inqryVoucherId',],
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                dealReplyVoucherList: [],
                inqryTitle: null,
                merchantName: null
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            let self = this;
            if(!Utils.isNoB(self.inqryVoucherId)) {
                self.getDealReplyVoucherList();
            }
        },
        methods: {
            viewImage: function (fileBrowseUrl) {
                Utils.setPageUrl(fileBrowseUrl, '_blank');
            },
            downloadFile: function (fileDownloadUrl) {
                Utils.downloadFile(getAppUrl(fileDownloadUrl));
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getDealReplyVoucherList();
            },
            getDealReplyVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                if(!Utils.isNoB(self.inqryVoucherId)) {
                    filterItems.inqryVoucherId = self.inqryVoucherId;
                }
                if(!Utils.isNoB(self.merchantName)) {
                    filterItems.merchantName = self.merchantName;
                }
                postData.filterItems = filterItems;
                let lastMsgBoxDlg = MsgBox.loading();
                dealApi.getDealReplyVoucherList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let data = result.data;
                        self.dealReplyVoucherList = data.rows;
                        //
                        let pagination = data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 加入合格商户
            addQualifiedMerchant: function (merchantId, merchantType) {
                // 为了使用原有的接口，设置数据
                let peerMerchantIds = [];
                peerMerchantIds.add(merchantId);
                //
                let postData = {};
                postData.bizRelIds = peerMerchantIds;
                postData.peerMerchantType = merchantType;
                let lastMsgBoxDlg = MsgBox.loading();
                merchtComnApi.saveMerchantBizRel(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result != null) {
                        if(result.type == 'info') {
                            MsgBox.success(result.message);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/InqryVoucher/DealReplyVoucherList.vue